import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Marquee from "react-fast-marquee";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useDispatch, useSelector } from "react-redux";
import { fetchHomepage } from "../redux/slices/homeSlice";

const HomeRap = styled.div`
  margin-top: 200px;
  .live-link {
    text-decoration: none;
    color: #363d4f;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    gap: 3px;
  }
  .all-live-links {
    background: #f3f4f5;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 15px;
    height: 36px;
    border-radius: 20px;
  }
  h1 {
    color: #060b13;
    font-size: 80px;
    font-weight: 700;
    max-width: 1000px;
    text-align: center;
    line-height: 90px;
  }
  .home-1 p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
    max-width: 483px;
    text-align: center;
    line-height: 25px;
  }
  .learn-btn,
  .trial-btn {
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    border-radius: 100px;
    height: 55px;
    border-color: #060b13;
    width: 150px;
    text-decoration: none;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
  }
  .trial-btn {
    background: #ed1c24;
    width: 190px;
    color: #ffffff;
  }
  .home-1-links {
    display: flex;
    gap: 15px;
  }
  .home-1 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    margin-top: 50px;
  }
  .events-text-divs {
    padding: 20px;
    border-radius: 5px;
    height: 246px;

    width: 320px;

    gap: 10px;
    cursor: pointer;
  }
  .push-down-event {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  .events-text-divs h4 {
    font-size: 12px;
    font-weight: 600;
    color: #ffffff;
    line-height: 17px;
    max-width: 183px;
  }
  .events-text-divs p {
    color: #dcdcdc;
    font-size: 12px;
    font-weight: 400;
  }
  .down-event-text {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .events-2 {
    border: 0.7px solid #bac0d499;
    border-radius: 20px;
    padding: 24px 32px;
    margin-top: 30px;
  }
  .down-event-text-div {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .the-play-audion-icon {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80%;
  }
  .event-round {
    width: 42px;
    border-radius: 50%;
    height: 42px;
  }
  .sub-home-3 {
    display: flex;
    gap: 30px;
    align-items: center;
  }
  .sub-home-3 img {
    margin: 0px;
  }
  .home-3 {
    margin-top: 60px;
  }
  .home-3 h4 {
    color: #060b13;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 30px;
  }
  .circle-mark {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ed1c24;
  }
  .circle-mark-div p {
    color: #060b13;
    font-size: 14px;
    font-weight: 600;
  }
  .circle-mark-div {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .home-4-left h2,
  .home-5-right h2 {
    color: #060b13;
    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    max-width: 488px;
  }
  .home-4-left p,
  .home-5-right p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
    line-height: 25px;
    max-width: 424px;
  }
  .color-p {
    color: #ed1c24 !important;
    font-size: 14px !important;
  }
  .home-4,
  .home-5 {
    margin-top: 100px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 150px;
  }
  .home-4-right,
  .home-5-left {
    position: relative;
  }
  .home-4-img {
    margin-right: 50px;
  }
  .anc-down {
    position: absolute;
    bottom: -135px;
    left: 40px;
  }
  .red-icon-1,
  .red-icon-3 {
    position: absolute;
    top: -90px;
    right: -90px;
  }
  .red-icon-3 {
    top: -70px;
    right: -20px;
  }
  .red-icon-2 {
    position: absolute;
    bottom: -100px;
    left: -130px;
  }
  .explored-btn-now {
    border-radius: 100px;
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: #060b13;
    color: #060b13;
    font-size: 16px;
    font-weight: 600;

    width: 150px;
    height: 55px;
    background: #ffffff !important;
  }
  .home-4-left,
  .home-5-right {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .home-6 p {
    color: #dedede;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
  }
  .home-6 h4 {
    color: #ffffff;
    font-size: 25px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 15px;
  }
  .sec-sub-home-6 {
    width: 550px;
  }
  .sub-home-6 {
    display: flex;
    gap: 20px;
    margin-top: 20px;
    padding: 0px 10px;
  }
  .home-6 {
    background: #ed1c24;
    border: 1px solid;
    border-image-source: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0) 0%,
      #ed1c24 70.11%
    );
    border-radius: 12px;
    height: 463px;
    width: 97%;
    margin: 20px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: center;
    align-items: center;
  }
  .down-card-text-sub p {
    color: #363d4f;
    font-weight: 400;
    font-size: 12px;
  }
  .down-card-text-sub h5 {
    color: #060b13;
    font-size: 16px;
    font-weight: 600;
  }
  .down-card-text-sub {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
  .down-card-text {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .upper-card-text p {
    color: #363d4f;
    font-size: 14px;
    font-weight: 400;
    max-width: 320px;
    line-height: 24px;
  }
  .upper-card-text {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .home-7-card {
    border: 1px solid #bac0d4b2;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    width: 379px;
  }
  .coma-img {
    width: 33px;
  }
  .home-7-upper h2 {
    color: #060b13;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
  }
  .home-7-upper p {
    color: #363d4f;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    line-height: 24px;
    max-width: 415px;
    text-align: center;
  }
  .home-7-upper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  .home-7-down {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: space-between;
    gap: 15px;
    margin-top: 50px;
  }
  .home-7 {
    margin-top: 100px;
  }
  .home-8 {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    margin: 100px 0px;
  }
  .red-stars {
    display: flex;
    align-items: center;
    gap: 5px;
  }
   @media (max-width: 1220px) {
    .home-7-down {
      grid-template-columns: repeat(2, 1fr);
    }
   }
  @media (max-width: 1024px) {
    .sub-home-3 {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 992px) {
    .home-4,
    .home-5 {
      flex-wrap: wrap;
      gap: 30px;
    }
    .home-7-down {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 850px) {
    .home-7-down {
      grid-template-columns: repeat(1, 1fr);
    }
    .home-7-card {
      width: 100%;
    }
  }
  @media (max-width: 678px) {
    h1 {
      font-size: 50px;
      line-height: 55px;
    }
    .sec-sub-home-6 {
      width: 500px;
    }
  }
  @media (max-width: 560px) {
    .home-4-img {
      width: 350px;
    }
    .anc-down {
      width: 450px;
    }
    .sec-sub-home-6 {
      width: 450px;
    }
    .home-8 {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 460px) {
    .home-4-img {
      width: 300px;
    }
    .anc-down {
      width: 350px;
    }
    .sec-sub-home-6 {
      width: 350px;
    }
  }
  @media (max-width: 370px) {
    .home-4-img {
      width: 230px;
    }
    .anc-down {
      width: 250px;
    }
    .sec-sub-home-6 {
      width: 300px;
    }
  }
`;

const Home = () => {
  const dispatch = useDispatch();
  const { homeObject, loading } = useSelector((state) => state.content);
  console.log(homeObject);

  const slider = homeObject?.data?.slider;
  const connect = homeObject?.data?.connect;
  const partners = homeObject?.data?.partners;
  const sectionFive = homeObject?.data?.section_five;
  const sectionFour = homeObject?.data?.section_four;
  const callToAction = homeObject?.data?.call_to_action;
  const testimonials = homeObject?.data?.testimonials;

  const events = [
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/image_9.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_1.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_11.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/image_12.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_13.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_14.png",
      color: "#98081C",
    },
    {
      title: "Prayer meeting with us at the salvation studio",
      text: "",
      bgImage: "/images/image_7.png",
      color: "#4A4A4A",
    },
    {
      title: "Top 10 naija hit",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_8.png",
      color: "#C4CBDB",
    },
    {
      title: "The Hour of Mercy",
      text: "Listen to naija hit live with...",
      bgImage: "/images/image_15.png",
      color: "#98081C",
    },
  ];

  useEffect(() => {
    dispatch(fetchHomepage());
  }, [dispatch]);
  return (
    <HomeRap>
      <div className="home-1 containery">
        <div className="all-live-links">
          <Link className="live-link">
            <img src="/images/h-live.png" alt="" />
            Livestream
          </Link>
          <Link className="live-link">
            <img src="/images/h-host.png" alt="" />
            Host
          </Link>
          <Link className="live-link">
            <img src="/images/h-share.png" alt="" />
            Share
          </Link>
        </div>
        <h1>{slider?.title}</h1>
        <p>{slider?.sub_title}</p>
        <div className="home-1-links">
          <a
            href={slider?.first_btn_link}
            target="_blank"
            rel="noopener noreferrer"
            className="learn-btn"
          >
            {slider?.first_btn_name}
          </a>

          <a href={slider?.second_btn_link} target="_blank" rel="noopener noreferrer" className="trial-btn">{slider?.second_btn_name}</a>
        </div>
      </div>
      <div>
        <Marquee pauseOnHover={true} speed={40} direction="left">
          {events.map((event, index) => (
            <div
              className="events-text-divs "
              key={index}
              style={{
                background: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 20.95%, rgba(0, 0, 0, 0.659617) 81.51%, #000000 103.25%), url('${event.bgImage}')`,
                backgroundSize: "cover",
                backgroundPosition: "cover",
                marginLeft: "20px",
                marginTop: "20px",
              }}
            >
              <div
                style={{
                  height: "100%",
                }}
              >
                <div className="the-play-audion-icon">
                  <img src="/images/audio_icon.png" alt="" />
                </div>
                <div className="push-down-event">
                  <div className="down-event-text-div">
                    <div
                      className="event-round"
                      style={{
                        background: `${event.color}`,
                      }}
                    ></div>
                    <div className="down-event-text">
                      <h4>{event.title}</h4>
                      <p>{event.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </Marquee>
      </div>
      <div className="home-3 containery">
        <h4>{partners?.partnerTitle?.title}</h4>
        <div className="sub-home-3">
          {partners?.partnerList?.map((partner, index) => (
            <img src={`https://admin.pluglr.com/${partner?.image}`} alt="" />
          ))}
         
        </div>
      </div>
      <div className="home-4 containery">
        <div className="home-4-left">
          <p className="color-p">{sectionFour?.title}</p>
          <h2>{sectionFour?.sub_title}</h2>
          <p>
            {sectionFour?.content}
          </p>
          <div className="circle-mark-div">
            <div className="circle-mark">
              <Icon
                width="14px"
                height="14px"
                icon="fluent-mdl2:check-mark"
                style={{ color: "#FFFFFF" }}
              />
            </div>
            <p>{sectionFour?.paragraph_one}</p>
          </div>
          <div className="circle-mark-div">
            <div className="circle-mark">
              <Icon
                width="14px"
                height="14px"
                icon="fluent-mdl2:check-mark"
                style={{ color: "#FFFFFF" }}
              />
            </div>
            <p>{sectionFour?.paragraph_two}</p>
          </div>
          <div className="circle-mark-div">
            <div className="circle-mark">
              <Icon
                width="14px"
                height="14px"
                icon="fluent-mdl2:check-mark"
                style={{ color: "#FFFFFF" }}
              />
            </div>
            <p>{sectionFour?.paragraph_three}</p>
          </div>
          <a href={sectionFour?.button_link} target="_blank" rel="noopener noreferrer" className="explored-btn-now">{sectionFour?.button_title}</a>
        </div>
        <div className="home-4-right">
          <img className="home-4-img" src={`https://admin.pluglr.com/${sectionFour?.banner}`} alt="" />
          <img className="anc-down" src={`https://admin.pluglr.com/${sectionFour?.image}`} alt="" />
          <img className="red-icon-1" src={`https://admin.pluglr.com/${sectionFour?.icon_one}`} alt="" />
          <img className="red-icon-2" src={`https://admin.pluglr.com/${sectionFour?.icon_two}`} alt="" />
        </div>
      </div>
      <div className="home-5 containery">
        <div className="home-5-left">
          <img className="home-4-img" src={`https://admin.pluglr.com/${sectionFive?.banner}`} alt="" />
          <img className="anc-down" src={`https://admin.pluglr.com/${sectionFive?.image}`} alt="" />
          <img className="red-icon-3" src={`https://admin.pluglr.com/${sectionFive?.icon_one}`} alt="" />
          <img className="red-icon-2" src={`https://admin.pluglr.com/${sectionFive?.icon_two}`} alt="" />
        </div>
        <div className="home-5-right">
          <p className="color-p">{sectionFive?.title}</p>
          <h2>{sectionFive?.sub_title}</h2>
          <p>
            {sectionFive?.content}
          </p>
          <a href={sectionFive?.button_link} target="_blank" rel="noopener noreferrer" className="explored-btn-now">{sectionFive?.button_title}</a>
        </div>
      </div>
      <div className="home-6 ">
        <div className="containery">
          <h4>{connect?.title}</h4>
          <p>{connect?.sub_title}</p>
        </div>
        <div className="sec-sub-home-6">
          <Marquee pauseOnHover={true} speed={20} direction="left">
            <div className="sub-home-6">
              {connect?.connectList?.map((connect, index) => (
                <img src={`https://admin.pluglr.com/${connect?.image}`} alt="" />
              ))}
              
            </div>
          </Marquee>
        </div>
      </div>
      <div className="home-7 containery">
        <div className="home-7-upper">
          <h2>{testimonials?.testTitle?.title}</h2>
          <p>
            {testimonials?.testTitle?.sub_title}
          </p>
        </div>
        <div className="home-7-down">
          {testimonials?.testList?.map((testimonial, index) => (
            <div className="home-7-card">
              <div className="upper-card-text">
                <img className="coma-img" src="/images/coma.png" alt="" />
                <p>
                  {testimonial?.testimony}
                </p>
              </div>
              <div className="down-card-text">
                <img src={`https://admin.pluglr.com/${testimonial?.image}`} alt="" />
                <div className="down-card-text-sub">
                  <h5>{testimonial?.full_name}</h5>
                  <p>{testimonial?.title}</p>
                </div>
              </div>
            </div>
          ))}
         
        </div>
      </div>
      <div className="home-8">
        <div>
          <img src="/images/cap-logo.png" alt="" />
        </div>
        <div className="red-stars">
          <img src="/images/full-red-star.png" alt="" />
          <img src="/images/full-red-star.png" alt="" />
          <img src="/images/full-red-star.png" alt="" />
          <img src="/images/full-red-star.png" alt="" />
          <img src="/images/half-red-star.png" alt="" />
        </div>
        <div>
          <img src="/images/green-star.png" alt="" />
        </div>
      </div>
    </HomeRap>
  );
};

export default Home;
